module.exports = __webpack_public_path__ + "img/bracket-round-right.18a908d6.svg";